$(document).ready(function(){
    loadCustomProductsData();
});

document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    loadCustomProductsData();
    
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    loadCustomProductsData();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    loadCustomProductsData();
});

function loadCustomProductsData() {
    if($('.product').length){
        $('.product').each(function() {
            var sku = $(this).find('span[data-micro="sku"]').text().toString(); 
            if (productInfoByCode.hasOwnProperty(sku)) {
                var weightPerItem = productInfoByCode[sku].weight;
                var weightForThisItem = $(this).find('div[data-micro="offer"]').attr('data-micro-price') / weightPerItem;
                $(this).find('.prices').append('<span class="price-measure">'+Number(weightForThisItem).ShoptetFormatAsCurrency()+' / 1 kg</span>')
              
            }
        });
    }
    
}